import axios from "axios";
import queryString from "query-string";
import {errorMsg} from "../helper/message";
import {getCmsToken, setCmsToken} from "../helper/user";
import {getDataSession, LOCAL_STORAGE} from "helper/session";
import {LIST_LANGUAGUE} from "theme/layout/LanguageButton";
import {notifyError} from "../helper/system-notify";

export const baseUrlGateWay = window.location.origin.includes("localhost")
  ? `${process.env.REACT_APP_GATE_WAY_ENDPOINT}`
  : `${window.location.origin}/gateway`;

export const AUTH_BASE_URL = baseUrlGateWay;

export const API_UAA_REFRESH_TOKEN = "/oauth/login";
const requestAuth = axios.create({
  baseURL: AUTH_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) =>
      queryString.stringify(params, { arrayFormat: "comma" }),
  },
});

export const middlewareRequest = async (config) => {
  const languageCode = getDataSession(LOCAL_STORAGE, "languageCode");
  const currentLang = LIST_LANGUAGUE.find(
    (item) => item.code.toLocaleLowerCase() === languageCode
  );

  try {
    let temp = {
      ...config,
      headers: {
        ...config?.headers,
        // "Accept-Language": i18n.language
        //   ? i18n.language.substring(0, 2)
        //   : "en-US",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0",
        "Accept-Language": currentLang.codeHeader ?? "en-US",
      },
    };
    if (config?.disableToken) {
      return temp;
    }
    const tokenAccess = getCmsToken();
    if (config.url === API_UAA_REFRESH_TOKEN) {
      return temp;
    }
    return {
      ...temp,
      headers: {
        ...temp.headers,
        Authorization: `Bearer ${tokenAccess?.access_token}`,
      },
    };
  } catch (err) {
    errorMsg(err, "System error");
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  }
};

export const middlewareResponse = (response) => {
  try {
    if (!!response?.data?.errorCodes) {
      notifyError(response);
      return Promise.reject(
        response?.data?.errorCodes?.[0]?.message ??
        response?.data?.errorCodes ??
        "System error"
      );
    }
    return response;
  } catch (err) {
    errorMsg(err, "System error");
    // localStorage.clear();
    // sessionStorage.clear();
    // window.location.replace("/login");
  }
};

let isRefreshing = false;
let subscribers = [];

export const middlewareResponseError = (error) => {
  const { config } = error;

  if (!!error?.response?.status) {
    const status = error?.response?.status;
    const originalRequest = config;

    if (status === 403) {
      return Promise.reject("Access to the requested resource is Forbidden");
    }

    if (status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        const { refresh_token } = getCmsToken();
        // Send a request to refresh the access token
        const api = AUTH_BASE_URL + API_UAA_REFRESH_TOKEN;
        const requestBody = {
          grant_type: "refresh_token",
          refresh_token,
        };

        return axios
          .post(api, requestBody)
          .then(({ data }) => {
            setCmsToken(data?.data);
            const { access_token } = data?.data;
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            subscribers.forEach((callback) => callback(access_token));

            subscribers = [];
            return axios(originalRequest);
          })
          .catch((error) => {
            // Clear the user's session and redirect to the login page
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace("/login");
            return Promise.reject(error);
          })
          .finally(() => {
            isRefreshing = false;
          });
      } else {
        return new Promise((resolve) => {
          subscribers.push((access_token) => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            resolve(axios(originalRequest));
          });
        });
      }
    }
    notifyError(error);
  } else {
    notifyError(error);
    return Promise.reject(error);
  }
};

requestAuth.interceptors.request.use(middlewareRequest, (error) => {

  console.log(error)
      return Promise.reject(error)
    }
);

requestAuth.interceptors.response.use(
  middlewareResponse,
  middlewareResponseError
);

const authApi = (options) => {
  return requestAuth({
    ...options,
    headers: { "Accept-Language": "vi", ...options.headers },
  });
};

export default authApi;
